<template>
    <page class="login">
        <v-title title="Login"></v-title>
        <div class="container">
            <template v-if="!user">
                <form @submit.prevent="login(slug)" class="gutter-xs q-pa-xs q-pa-lg" @keydown="form.onKeydown($event)">
                    <!-- MSISDN -->
                    <div class="col-12 self-end q-pa-lg">
                        <v-input path="dcb_msisdn"
                                 v-model="form.msisdn"
                                 :label="$t('msisdn')"
                                 type="text"
                                 color="primary"
                                 :form="form"
                                 :placeholder="$T('insert your msisdn')">
                        </v-input>
                    </div>

                    <!-- Password -->
                    <div class="col-12 self-end q-pa-lg">
                        <v-input path="password"
                                 v-model="form.password"
                                 :label="$t('password')"
                                 type="password"
                                 color="primary"
                                 :form="form"
                                 :placeholder="$T('insert your password')">
                        </v-input>
                    </div>

                    <div class="col-12 self-end q-pa-lg">
                        <v-submit no-caps color="primary" link class="full-width super-hover"
                                  :label="$T('log in')" :loadingLabel="$t('validating...')"
                                  :form="form"></v-submit>
                    </div>
                    <div class="col-12 self-end q-pa-lg">
                        <v-button no-caps color="secondary" link class="full-width super-hover" :label="$T('lost password')" @click="lostPassword()" ></v-button>
                    </div>
                </form>
            </template>
        </div>
    </page>
</template>

<script>
    import {mapGetters} from 'vuex'
    import Form from 'vform'
    import {QModal, QSpinnerPuff, QBtn, QCheckbox, QInput} from 'quasar-framework'
    import VButton from "../../components/form/VButton";

    export default {
        name: 'VLogin',

        components: {
            VButton,
            QModal,
            QBtn,
            QSpinnerPuff,
            QCheckbox,
            QInput
        },

        data: () => ({
            form: new Form({
                msisdn: '',
                password: '',
                remember: false,
                redirectTo: this.slug,
            }),
            logo: `${config.appUrl}${config.devAssetsFolder}/img/p4f.svg`
        }),

        computed: {
            ...mapGetters({
                user: 'auth/user',
                settings: 'local/settings'
            }),
            showLogin: {
                get() {
                    return this.settings('login')
                },
                set(value) {
                    this.$store.dispatch('local/set', {key: 'login', value})
                }
            },
            slug: {
                get() {
                    return this.settings('redirect-route')
                },
                set(value) {
                    this.$store.dispatch('local/set', {key: 'redirect-route', value})
                }
            },
        },

        methods: {
            redirectToWapBilling() {
                axios.get(`${config.appUrl}/api/service-url`)
                    .then(({data}) => {
                        window.location.href = data;
                    })
            },
            lostPassword() {
                return this.$router.push("/password/reset")
            },
            async login(slug) {
                this.form.redirectTo = (slug != undefined) ? slug : "/";

                // Submit the form.
                if(!this.$route.query.hasOwnProperty('error_n'))
                {
                    const {data} = await this.form.post(`${config.SkySMSUrl}/login`)

                    console.log("Data", data)
                    return false

                    if(!data.success) {
                        this.$q.notify({
                            color: 'red',
                            icon: 'warning',
                            message: data.message,
                            detail: "",
                            position: 'top'
                        })

                        return false
                    }

                    this.$store.dispatch('auth/saveToken', {
                        token: data.token,
                        remember: true
                    })

                    this.$store.dispatch('auth/fetchUser')

                    //router.push('/welcome')
                    //window.location.href = '/welcome'
                }


            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/auth/login.vue